import { createFileRoute, Outlet } from "@tanstack/react-router";

import { Role } from "@/store";
import { requireRoles } from "@/utils/requiredRoles";

export const Route = createFileRoute("/_private/dashboard/_base/produtos")({
  component: Outlet,
  //TODO não sei se admin poderá ver produtos já que na visão de admin no antigo não existe essa seção
  beforeLoad: requireRoles({ allowed: [Role.Usuario] })
});
